<template>
<el-dialog
    title="Memo"
    :visible.sync="dialogVisible"
    width="546px">
    <el-input
      type="textarea"
      rows="10"
      v-model="memo"
      maxlength="500"
      show-word-limit
      @keydown.native="memoChange($event)"
    ></el-input>
  <div class="memo-footer">
        <span slot="footer" class="dialog-footer" center>
          <el-button type="primary" class="memo-footer-button btn-black" @click="editSubmit">Submit</el-button>
          <el-button @click="dialogVisible = false" class="memo-footer-button">Cancel</el-button>
        </span>
      </div>
</el-dialog>
</template>

<script>
import { putAction } from '@/api/manage.js'
export default {
  name: 'editMemo',
  props: {
    message: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      dialogVisible: false,
      memo: ''
    }
  },
  methods: {
    editSubmit() {
      if (this.message.type === 'invoice') {
        this.$parent.editInvoice('memo', this.memo)
        this.dialogVisible = false
      } else {
        putAction(`/order/address/${this.$route.query.orderId}`, {
          memo: this.memo
        }).then((res) => {
        // console.log(res)
          if (res.success) {
            this.dialogVisible = false
            this.$parent.loadOrderDetails()
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    memoChange(e) {
      if (e.keyCode === 13) { e.returnValue = false }
    }
  },
  watch: {
    message: function(newVal, oldVal) {
      this.memo = newVal.memo
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header{
  padding: 22px;
}
/deep/.el-dialog__body{
  padding: 0 20px;
}
  .memo-footer{
  padding: 27px 0;
  display: flex;
  justify-content: center;
  .memo-footer-button{
    width: 142px;
    height: 40px;
  }
}
.btn-black{
  background: #000000;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/edit-memo.vue